import styled from 'styled-components';
import { themeGet, getBackgroundColor, getTextColor } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
export const Wrapper = styled(Flex)``;
export const Counter = styled.span`
  background-color: ${props => props.color || getBackgroundColor('primary')(props)};
  border-radius: 50%;
  color: ${props => getTextColor('lightest')(props)};
  min-width: ${props => themeGet('space.3')(props)}px;
  min-height: ${props => themeGet('space.3')(props)}px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
`;